<template>
  <div class="home_search" :class="{ 'smart-search-active': smartSearchActive }">
    <div class="bg_box">
      <img src="../../../assets/newImage/bg_new_1.png"  alt=""/>
    </div>
    <!--    <img src="../../../assets/newImage/qiuguo.jpg" alt="" style="width: 100%;height: 217px;object-fit: contain;margin-top: 2px"/>-->
    <div class="search-stage" :class="{ 'guest-search': !$commonUtil.isLogin() }">
    <SmartHotelSearch ref="smartSearch" v-show="smartSearchActive" @change-mode="smartSearchActive = $event" @search-state-change="smartHasSearched = $event" />
    <div v-show="!smartSearchActive">
    <SearchForm translucent @toSerch="toSerch" :btnText="$t('search.searchBtn')">
      <SearchModeSwitch slot="searchMode" @change="smartSearchActive = $event" v-if="isTestAccount"/>
    </SearchForm>
    </div>
    </div>
    <div class="main_body_introduce" v-show="!smartSearchActive || !smartHasSearched">
      <div></div>
      <div class="introduce_box">
        <div style="font-size: 24px;font-weight: bold;margin-bottom: 50px;color: #FFFFFF"
             class="title_item">{{ $t('center.our_service') }}
        </div>
        <div class="introduce_item">
          <div class="item_box">
            <div class="item_img">
              <img src="@/assets/newImage/diqiu.png" alt="">
            </div>
            <div class="item_info">
              <div class="title">全球覆盖</div>
              <div class="desc">{{ $t('register.many_hotel_desc') }}</div>
            </div>
          </div>
          <div>
            <div class="item_box">
              <div class="item_img">
                <img src="@/assets/newImage/zhenghe.png" alt="">
              </div>
              <div class="item_info">
                <div class="title">最优选择</div>
                <div class="desc">{{ $t('register.best_sel_desc') }}</div>
              </div>
            </div>
          </div>
          <div>
            <div class="item_box">
              <div class="item_img">
                <img src="@/assets/newImage/fwbaozhang.png" alt="">
              </div>
              <div class="item_info">
                <div class="title">7 x 24小时服务</div>
                <div class="desc">{{ $t('register.service_guarantee_desc') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
    <div v-show="!smartSearchActive" class="regular-content-section">
    <div class="main_body_recommend">
      <div></div>
      <div :style="$commonUtil.isLogin() ? 'margin-bottom: 100px' : ''">
        <div style="font-size: 36px;font-weight: bold;margin-bottom: 50px;">{{ $t('center.HOTEL_RECOMMENDATION') }}
        </div>
        <div class="sel_city_box"
             :class="[accountType == 3 ? 'all' : '', accountType == 2 ? 'region_oversea' : '', accountType == 1 ? 'region_chain' : '']">
          <div class="item_content">
            <div v-for="(item, index) in recommendCity" :key="index">
              <span class="item" :class="item.status ? 'sel' : ''" @click="clickCity(item)"
                    v-html="isLang ? item.name : item.nameCn"></span>
            </div>
          </div>
        </div>
        <div v-loading="isSelCityHotels">
          <el-carousel :interval="5000" height="400px" indicator-position="outside" @change="carouselChane">
            <el-carousel-item v-for="(item, index) in recommendHotels" :key="index" class="carousel-item">
              <div class="hot_hotel_box" v-for="(i, ind) in item" :key="ind" @click="toDetail(i)">
                <div style="height: 200px;overflow:hidden;border-radius: 8px 8px 0 0">
                  <img :src="i.hotelImages" v-if="i.hotelImages">
                  <img src="../../../assets/newImage/noSwiperImg.png" v-else/>
                </div>
                <span class="score_box" v-if="i.score && i.score > 0">
                  <i class="el-icon-star-on" style="color: #ffb800"/>
                  {{ i.score }}
                </span>
                <p style="font-size: 18px;font-weight: bold;"
                   v-html="isLang ? i.nameEn ? i.nameEn : i.nameCn : i.nameCn ? i.nameCn : i.nameEn">
                </p>
                <p style="font-size: 13px;color: #696969;">
                  <i class="el-icon-location-outline" />
                  {{ i.addressCn }}
                </p>
                <div style="margin-left: 15px">
                  <div class="hotel_star" v-if="i.star">
                    <el-rate v-model="i.star" disabled></el-rate>
                  </div>
                  <div class="hotel_star" v-if="!i.star && i.category">
                    <el-rate v-model="i.category" disabled disabled-void-icon-class="iconfont icon-zuanshi"
                             :icon-classes="['iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi']"></el-rate>
                  </div>
                  <div class="hotel_star" v-if="!i.star && !i.category">
                    <el-rate :value="2" disabled></el-rate>
                  </div>
                </div>
                <p
                  style="font-size: 16px;color: #1e50f0;font-weight: bold;border-top: 1px solid #f3f4f6;padding-top: 10px;">
                  CNY {{ i.price }}起</p>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div></div>
    </div>
    <div class="main_body_register" v-if="!$commonUtil.isLogin()">
      <div class="to_register">
        <div style="margin-bottom: 30px;">
          <span style="font-size: 30px;font-weight: bold;">{{ $t('login.get_hotels') }}</span>
        </div>
        <div>
          <span
            style="font-size: 15px;border: 1px solid #fff;padding: 6px 22px;font-family: '苹方';border-radius: 5px;cursor: pointer;"
            @click="$router.push('/Register')">
            {{ $t('login.register_now').replace(',', '') }}
          </span>
        </div>
      </div>
    </div>
    <ContantUs/>
    </div>
  </div>
</template>

<script>
import ContantUs from './components/ContantUs.vue'
import SearchForm from './components/SearchForm.vue'
import SmartHotelSearch from './components/smartHotelSearch/index.vue'
import SearchModeSwitch from './components/smartHotelSearch/SearchModeSwitch.vue'
import { saveSearchReturnState, takeSearchReturnState, clearSearchReturnState } from './components/smartHotelSearch/searchReturnState'

export default {
  beforeRouteLeave (to, from, next) {
    const search = this.$refs.smartSearch
    if (to.name === 'bookingDetail' && this.smartSearchActive && search && search.hasSearched) {
      saveSearchReturnState({
        region: search.region,
        query: search.query,
        submittedQuery: search.submittedQuery,
        requirements: search.requirements,
        hotels: search.hotels,
        actualSearchCondition: search.actualSearchCondition
      })
    } else {
      clearSearchReturnState()
    }
    next()
  },
  beforeRouteEnter (to, from, next) {
    const state = from.name === 'bookingDetail' ? takeSearchReturnState() : null
    if (from.name !== 'bookingDetail') clearSearchReturnState()
    next(vm => {
      if (!state) return
      Object.assign(vm.$refs.smartSearch, state, { hasSearched: true })
      vm.smartSearchActive = true
      vm.smartHasSearched = true
      vm.$emit('search-mode-change', true)
    })
  },
  data () {
    return {
      smartSearchActive: false,
      smartHasSearched: false,
      accountType: 3,
      recommendCityData: [
        {
          name: 'Shenzhen',
          nameCn: '深圳',
          cityCode: 'CT440300',
          regionId: 1,
          status: false
        }, {
          name: 'Beijin',
          nameCn: '北京',
          cityCode: 'CT110100',
          regionId: 1,
          status: false
        }, {
          name: 'Guangzhou',
          nameCn: '广州',
          cityCode: 'CT440100',
          regionId: 1,
          status: false
        }, {
          name: 'Shanghai',
          nameCn: '上海',
          cityCode: 'CT310100',
          regionId: 1,
          status: false
        }, {
          name: 'Chongqing',
          nameCn: '重庆',
          cityCode: 'CT500100',
          regionId: 1,
          status: false
        }, {
          name: 'Hong Kong',
          nameCn: '香港',
          cityCode: 'CT810100',
          regionId: 1,
          status: false
        }, {
          name: 'Kuala Lumpur',
          nameCn: '吉隆坡',
          cityCode: 'KK102103',
          regionId: 2,
          status: false
        }, {
          name: 'Bangkok',
          nameCn: '曼谷',
          cityCode: 'KK100103',
          regionId: 2,
          status: false
        }, {
          name: 'Tokyo',
          nameCn: '东京',
          cityCode: 'KK126361',
          regionId: 2,
          status: false
        }
      ],
      recommendHotels: [],
      isSelCityHotels: false,
      currentInfo: {}
    }
  },
  watch: {
    smartSearchActive (active) {
      this.$emit('search-mode-change', active)
    }
  },
  created () {
    if (this.$common.getAccountType()) {
      this.accountType = this.$common.getAccountType()
    }
    this.clickCity(this.recommendCity[0])
  },
  components: {
    SmartHotelSearch,
    SearchModeSwitch,
    SearchForm,
    ContantUs
  },
  methods: {
    carouselChane (e) {
      if (this.smartSearchActive) return
      if (e === 0) {
        let currenIndex = this.recommendCity.findIndex(item => item.status)
        if (currenIndex === this.recommendCity.length - 1) {
          currenIndex = -1
        }
        this.recommendCity.forEach(async (item, index) => {
          if (index === currenIndex + 1) {
            item.status = true
            await this.clickCity(item)
          } else {
            item.status = false
          }
        })
      }
    },
    toSerch () {
      this.$router.push('/HotelList')
    },
    async clickCity (e) {
      this.currentInfo = e
      this.isSelCityHotels = true
      this.recommendCityData.forEach(item => item.status = false)
      e.status = !e.status
      let req = {
        businessZone: '',
        checkIn: this.$common.formatterDate(new Date()),
        cityCode: e.cityCode,
        keyword: '',
        district: '',
        pageInx: 1,
        pageSize: 12,
        sortBy: 5,
        starRating: [],
        regionId: e.regionId
      }
      let partnerInfo = JSON.parse(this.$common.isLogin())
      if (!partnerInfo) {
        req.defaultUser = true
      }
      const {data: result} = await this.$http.post('/mini/searchCityHotels', req, {
        headers: {accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''}
      })
      this.isSelCityHotels = false
      if (result.code != 200) return this.$message.error(result.message)
      this.recommendHotels = this.groupArray(result.data.hotels, 4)
    },
    groupArray (array, subGroupLength) {
      let index = 0
      let newArray = []
      while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength))
      }
      return newArray
    },
    toDetail (e) {
      let checkIn = this.$common.formatterDate(new Date())
      let checkOut = this.$common.formatterDate(new Date(new Date().getTime() + 86400000))
      let obj = {
        room: 1,
        adult: 2,
        checkDates: [checkIn, checkOut],
        checkIn,
        checkOut,
        keyword: '',
        name: this.currentInfo.nameCn,
        cityCode: this.currentInfo.cityCode,
        channelId: null,
        regions: [],
        stars: [0],
        price: 0,
        siteType: 0,
        districtName: null,
        bizZoneName: null,
        starRating: null,
        hotelId: e.hotelId
      }
      localStorage.setItem('hotelDetailSearchForm', JSON.stringify(obj))
      window.open('/HotelDetail', '_blank')
    }
  },
  computed: {
    recommendCity () {
      if (this.accountType == 1) {
        let data = this.recommendCityData.filter(item => item.regionId == 1)
        data[0].status = true
        return data
      } else if (this.accountType == 2) {
        let data = this.recommendCityData.filter(item => item.regionId == 2)
        data[0].status = true
        return data
      } else if (this.accountType == 3) {
        this.recommendCityData[0].status = true
        return this.recommendCityData
      }
      return []
    },
    isLang () {
      return localStorage.getItem('lang') == 'en'
    },
    isTestAccount () {
      let partnerInfo = JSON.parse(this.$common.isLogin())
      return !partnerInfo ? false : partnerInfo.partnerCode === 1000 || partnerInfo.partnerCode === 1151 || partnerInfo.partnerCode === 1044
    }
  }
}
</script>

<style lang="less" scoped>
.home_search {
  .search-stage {
    &.guest-search /deep/ .main_body_search > div:nth-child(2),
    /deep/ .main_body_search.without-search-toolbar > div:nth-child(2) {
      min-height: 0;
    }
    padding-top: 10%;
    /deep/ .smart-hotel-search { padding-top: 0; padding-bottom: 40px; }
    /deep/ .smart-hotel-search.awaiting-search { padding-bottom: 0; }
    /deep/ .search-panel,
    /deep/ .main_body_search > div:nth-child(2) {
      min-height: 240px;
      box-sizing: border-box;
    }
    /deep/ .toolbar { height: 44px; margin-bottom: 20px; }
    /deep/ .query-examples { margin-top: 14px; }
    /deep/ .region_box { min-height: 69px; box-sizing: border-box; }
    /deep/ .main_content_item { box-sizing: border-box; min-height: 84px; }
  }
  .regular-content-section {
    position: relative;
    background-color: #fff;
    margin-top: 100px;
    padding-top: 60px;

    .main_body_recommend {
      margin-top: 0;
    }
  }
  position: relative;
  isolation: isolate;
  min-height: calc(100vh - 70px);
  // Both search modes share the same viewport-sized backdrop.
  .bg_box {
    position: fixed;
    top: 70px;
    right: 0;
    bottom: 0;
    left: 0;
    height: auto;
    display: block;
    width: auto;
    min-width: 0;
    pointer-events: none;
    background-color: #07346b;
    z-index: -1;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      height: 100%;
      margin-top: 0;
      object-fit: cover;
      object-position: center center;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4);
    }
  }

  .main_body_introduce {
    display: grid;
    margin-top: 100px;

    @media screen and (min-width: 992px) {
      grid-template-columns: auto 1180px auto;
    }

    .introduce_box {
      text-align: center;

      .title_item {
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 8px;

        &::before, &::after {
          content: '';
          display: inline-block;
          width: 30px;
          height: 2px;
          background-color: #FFFFFF;
        }
      }

      .introduce_item {
        display: grid;
        grid-template-columns: repeat(3, 288px);
        grid-column-gap: 127px;
        padding-left: 31px;
        color: #FFFFFF;

        .item_box {
          cursor: default;
          display: flex;
          text-align: left;
          column-gap: 10px;

          &:hover {
            .item_img {
              background-color: rgba(18, 38, 89, 1);
              border: 1px solid rgba(76, 73, 81, 0.6);
            }

            .item_info {
              .title {
                color: #0052ff;
              }
            }
          }

          .item_img {
            width: 58px;
            height: 58px;
            line-height: 48px;
            text-align: center;
            background-color: rgba(57, 53, 64, 1);
            border: 1px solid rgba(76, 73, 81, 0.6);
            border-radius: 8px;

            img {
              width: 32px;
              height: 32px;
            }
          }

          .item_info {

            .title {
              font-size: 18px;
              margin-bottom: 12px;
              font-weight: 600;
            }

            .desc {
              width: 148px;
              font-size: 14px;
              line-height: 20px;
            }
          }
        }
      }
    }

    @media screen and (max-width: 992px) {
      grid-template-columns: 10% 1fr 10%;
    }
  }

  .main_body_recommend {
    display: grid;
    margin-top: 10%;
    text-align: center;

    @media screen and (min-width: 992px) {
      grid-template-columns: auto 1280px auto;
    }

    .sel_city_box {

      // display: grid;

      // &.all {
      //   grid-template-columns: repeat(9, auto);
      // }

      // &.region_chain {
      //   grid-template-columns: repeat(6, auto);
      // }

      // &.region_oversea {
      //   grid-template-columns: repeat(3, auto);
      // }

      margin-bottom: 60px;

      .item_content {
        display: flex;
        justify-content: center;
      }

      .item {
        font-size: 16px;
        margin-right: 15px;
        cursor: pointer;
        user-select: none;
        padding: 6px 18px;
        color: #6a7282;

        &:hover {
          color: #1e50f0;
        }

        &.sel {
          position: relative;
          color: #1e50f0;

          &::before {
            content: '';
            display: inline-block;
            position: absolute;
            top: 100%;
            width: 50%;
            height: 4px;
            border-radius: 4px 4px 0 0;
            background-color: #1e50f0;
          }
        }
      }
    }

    .carousel-item {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
      gap: 15px;
      background-color: #FFFFFF;
      padding: 15px;
    }

    .hot_hotel_box {
      text-align: left;
      cursor: pointer;
      background-color: #fff;
      border-radius: 8px;
      position: relative;
      box-shadow: 0 4px 20px rgba(0, 0, 0, .04);

      &:hover {
        box-shadow: 0 12px 32px rgba(0, 0, 0, .12);
        transition: all .5s;
      }

      .score_box {
        position: absolute;
        right: 10px;
        top: 10px;
        padding: 5px 10px;
        border-radius: 6px;
        font-size: 13px;
        color: #FFFFFF;
        background-color: rgba(0, 0, 0, .5);
      }

      &:hover {
        img {
          transform: scale(1.1);
          transition: all 1s;
        }
      }

      img {
        object-fit: cover;
        width: 100%;
        height: 200px;
        border-radius: 8px 8px 0 0;
      }

      p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin: 15px;
        font-family: '苹方';
      }
    }

    @media screen and (max-width: 992px) {
      grid-template-columns: 10% 1fr 10%;
    }

    /deep/ .el-carousel__arrow--left {
      background-color: #FFFFFF;
      width: 60px;
      height: 60px;
      margin-left: -30px;
      box-shadow: 0 12px 23px rgba(0, 0, 0, .08);
      font-size: 24px;
    }

    /deep/ .el-carousel__arrow--right {
      background-color: #FFFFFF;
      width: 60px;
      height: 60px;
      margin-right: -30px;
      box-shadow: 0 12px 23px rgba(0, 0, 0, .08);
      font-size: 24px;
    }

    /deep/ .el-carousel__indicators--outside button {
      background-color: #1e50f0;
    }
  }

  .main_body_register {
    background-image: url('../../../assets/newImage/bg_1.jpg');
    width: 100%;
    height: 150px;
    background-size: cover;
    text-align: center;
    color: #fff;
    position: relative;
    margin-top: 100px;

    .to_register {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/HomeSearch.vue